import { cn } from "@/common/utils";
import CustomTypography from "@/components/Typography/CustomTypography";

export default function DefaultTextColumn({
  text,
  className,
  labelClassName,
}: {
  text: string | number | null;
  className?: string;
  labelClassName?: string;
}) {
  return (
    <div className={cn("py-4", className)}>
      <CustomTypography
        as="span"
        case={"normal"}
        size={"14px"}
        weight={"light"}
        className={["text-nowrap", labelClassName].join(" ")}
      >
        {!text && text !== 0 ? "No data" : text}
      </CustomTypography>
    </div>
  );
}
